/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_ThanksInputs */

const en_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Thanks`)
};

const ar_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا، شكرًا`)
};

const de_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, danke`)
};

const es_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, gracias`)
};

const fr_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non merci`)
};

const it_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, grazie`)
};

const ja_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結構です`)
};

const ko_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`괜찮아요`)
};

const pt_br_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, obrigado`)
};

const ru_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет, спасибо`)
};

const th_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ ขอบคุณ`)
};

const tr_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayır, teşekkürler`)
};

const zh_cn_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先不用，谢谢`)
};

const zh_tw_no_thanks = /** @type {(inputs: No_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先不用，謝謝`)
};

/**
* | output |
* | --- |
* | "No Thanks" |
*
* @param {No_ThanksInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const no_thanks = /** @type {((inputs?: No_ThanksInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_ThanksInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_thanks(inputs)
	if (locale === "ar") return ar_no_thanks(inputs)
	if (locale === "de") return de_no_thanks(inputs)
	if (locale === "es") return es_no_thanks(inputs)
	if (locale === "fr") return fr_no_thanks(inputs)
	if (locale === "it") return it_no_thanks(inputs)
	if (locale === "ja") return ja_no_thanks(inputs)
	if (locale === "ko") return ko_no_thanks(inputs)
	if (locale === "pt_br") return pt_br_no_thanks(inputs)
	if (locale === "ru") return ru_no_thanks(inputs)
	if (locale === "th") return th_no_thanks(inputs)
	if (locale === "tr") return tr_no_thanks(inputs)
	if (locale === "zh_cn") return zh_cn_no_thanks(inputs)
	return zh_tw_no_thanks(inputs)
});